import React, { useState } from "react"

import WindowDialog from "components/dialog/WindowDialog"



import DialogReuniaoForm from "../../../Reuniao/components/ReuniaoForm/DialogReuniaoForm"

import { Button } from "@mui/material"
import { Box } from "@mui/system"

export default function DialogNovaReuniao({ rodada, inscritos, reunioes, overSaveReuniao }) {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button onClick={() => setOpen(true)}>
                Nova Reunião
            </Button>
            {open &&
                <WindowDialog
                    title={rodada ? "Nova Reunião - " + rodada.nome : "Nova Reunião"}
                    onClose={() => {
                        setOpen(false)
                    }}
                    open={open}
                    titleButtons={
                        <Box sx={{ display: "flex", gap: 1 }}>
                        </Box>
                    }
                >
                    {() => {
                        return (
                            <DialogReuniaoForm setOpen={setOpen} rodada={rodada} inscritos={inscritos} reunioes={reunioes} overSave={overSaveReuniao} />
                        )
                    }}
                </WindowDialog>
            }
        </>
    )
}